import { Button, Card, CardContent, Collapse, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PlaceIcon from '@mui/icons-material/Place';
import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import DialogCorregirFichaje from './DialogCorregirFichaje';
import TimerOffIcon from '@mui/icons-material/TimerOff';
import { DialogAnularFichaje } from './DialogAnularFichaje';
import CircleIcon from '@mui/icons-material/Circle';

export const FichajeCard = ({ fichaje, nombreMes, fichajesUsuario, usuarioId, esadmin }) => {

    const [desplegado, setDesplegado] = useState(false);
    const [openCorregir, setOpenCorregir] = useState(false);
    const [fichajeCorregir, setFichajeCorregir] = useState(null);
    const [openAnular, setOpenAnular] = useState(false);
    const [fichajeAnular, setFichajeAnular] = useState(null);

    const Hora = (fecha) => fecha ? fecha.split(" ")[1].slice(0, 5) : "";

    const formatTime = (segundos) => {
        const h = Math.floor(segundos / 3600);
        const m = Math.floor((segundos % 3600) / 60);
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    };

    const sumarTiempos = (regs) => {
        // IDs que deben ser descartados por corrección
        const idsCorregidos = regs
            .filter(r => r.id_fichaje_corrector !== 0)
            .map(r => r.id_fichaje_corrector);

        // Filtramos válidos:
        // 1. debe tener inicio y fin
        // 2. no debe estar eliminado
        // 3. no debe estar corregido
        const validos = regs.filter(r =>
            r.hora_inicio &&
            r.hora_fin &&
            r.eliminado !== "1" &&      // ⬅️ NUEVO: excluir eliminados
            !idsCorregidos.includes(r.id_fichaje)
        );

        // Sumar
        const total = validos.reduce((a, r) => a + parseInt(r.total || 0), 0);

        return formatTime(total);
    };


    const contarTurnos = (regs) => {
        // IDs de registros corregidos
        const idsCorregidos = regs
            .filter(r => r.id_fichaje_corrector !== 0)
            .map(r => r.id_fichaje_corrector);

        // Contar solo registros válidos:
        // - tienen inicio y fin
        // - no están eliminados
        // - no están corregidos
        return regs.filter(r =>
            r.hora_inicio &&
            r.hora_fin &&
            r.eliminado !== "1" &&      // ⬅️ NUEVO: excluir eliminados
            !idsCorregidos.includes(r.id_fichaje)
        ).length;
    };

    const handleClick = (lat, lon) => {
        window.open(`https://www.google.com/maps?q=${lat},${lon}`, '_blank');
    };
    function formatearFecha(fechaStr) {
        if (!fechaStr) return "";

        // fechaStr = "2025-12-05 13:20:34"
        const [fecha, hora] = fechaStr.split(" ");

        if (!fecha || !hora) return "";

        const [yyyy, MM, dd] = fecha.split("-");
        const [hh, mm] = hora.split(":");

        return `${hh}:${mm} ${dd}/${MM}/${yyyy}`;
    }

    const esCorrectorSinOriginal = (reg) => {
        return (
            Number(reg.id_fichaje_corrector) === 0 &&
            reg.fecha_corrector !== null &&
            reg.id_usuario_corrector !== null
        );
    };


    return (
        <Grid container xs={12} marginBottom="0.5em">
            <Card sx={{ width: "100%", borderRadius: 3, boxShadow: 3, background: "var(--fondoTarjeta)" }}>
                <CardContent>

                    {/* HEADER */}
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <Typography variant="h5">
                                {nombreMes + " " + fichaje.fecha.split("-")[2]}
                            </Typography>
                        </Grid>

                        <Grid item xs={10} sm={7} container gap={4}>
                            <Typography variant="subtitle1">
                                {sumarTiempos(fichaje.registros)}
                            </Typography>
                            <Typography variant="subtitle1">
                                Turnos: {contarTurnos(fichaje.registros)}
                            </Typography>
                        </Grid>

                        <Grid item xs={2} sm={2}>
                            <Button onClick={() => setDesplegado(!desplegado)}>
                                {desplegado ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </Button>
                        </Grid>
                    </Grid>

                    {/* RESUMEN */}
                    <Grid container marginTop="1em">
                        {(() => {
                            const orig = fichaje.registros.filter(r => r.id_fichaje_corrector === 0);
                            const primero = orig[0];
                            const ultimo = orig[orig.length - 1];

                            return (
                                <Grid container>
                                    <Grid item xs={12} sm={3}><strong>Primera entrada:</strong> {Hora(primero?.hora_inicio)}</Grid>
                                    <Grid item xs={12} sm={3}><strong>Última salida:</strong> {ultimo?.hora_fin ? Hora(ultimo.hora_fin) : "En curso"}</Grid>
                                    <Grid item xs={12} sm={3}><strong>Total:</strong> {sumarTiempos(fichaje.registros)}</Grid>
                                    <Grid item xs={12} sm={3}><strong>Turnos:</strong> {contarTurnos(fichaje.registros)}</Grid>
                                </Grid>
                            );
                        })()}
                    </Grid>

                    {/* TABLA */}
                    <Collapse in={desplegado} timeout="auto" unmountOnExit>
                        <Grid container marginTop="1em">
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell><strong>ID</strong></TableCell>
                                            <TableCell><strong>Horas</strong></TableCell>
                                            <TableCell><strong>Inicio</strong></TableCell>
                                            <TableCell><strong>Fin</strong></TableCell>
                                            <TableCell><strong>Corrección</strong></TableCell>
                                            <TableCell><strong>Anulado</strong></TableCell>
                                            <TableCell><strong>Observación</strong></TableCell>
                                            <TableCell align="center"><strong>Ubicación Inicio</strong></TableCell>
                                            <TableCell align="center"><strong>Ubicación Fin</strong></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {(() => {

                                            const originales = fichaje.registros.filter(r => r.id_fichaje_corrector === 0);
                                            const correctores = fichaje.registros.filter(r => r.id_fichaje_corrector !== 0);

                                            // Agrupación por original
                                            const mapa = {};
                                            correctores.forEach(c => {
                                                if (!mapa[c.id_fichaje_corrector]) mapa[c.id_fichaje_corrector] = [];
                                                mapa[c.id_fichaje_corrector].push(c);
                                            });
                                            console.log(mapa);

                                            // Ordenamos correctores
                                            Object.values(mapa).forEach(arr =>
                                                arr.sort((a, b) => a.id_fichaje - b.id_fichaje)
                                            );

                                            // Construimos lista lineal con todos los datos que ya tenías
                                            let lista = [];
                                            let grupos = []; // lista de {inicio, fin}

                                            let idx = 0;

                                            originales.forEach(orig => {
                                                const corr = mapa[orig.id_fichaje] || [];

                                                const inicioGrupo = idx;

                                                // Último corrector NO anulado
                                                const ultimoValido = corr.filter(c => Number(c.eliminado) === 0).pop();
                                                const esOriginalCorregido = !!ultimoValido;

                                                lista.push({
                                                    ...orig,
                                                    esCorrector: false,
                                                    esOriginalCorregido,
                                                    esAnulado: Number(orig.eliminado) === 1,
                                                    tieneBarra: corr.length > 0
                                                });
                                                idx++;

                                                corr.forEach(c => {
                                                    lista.push({
                                                        ...c,
                                                        esCorrector: true,
                                                        esCorrectorAnulado: Number(c.eliminado) === 1,
                                                        tieneBarra: true
                                                    });
                                                    idx++;
                                                });

                                                const finGrupo = idx - 1;
                                                grupos.push({ inicio: inicioGrupo, fin: finGrupo });
                                            });

                                            return lista.map((reg, i) => {
                                                const estadoFicha = (() => {
                                                    if (reg.eliminado === "1") return "Anulado";

                                                    if (reg.id_fichaje_corrector !== 0 || esCorrectorSinOriginal(reg))
                                                        return "Corrector";

                                                    if (reg.esOriginalCorregido) return "Corregido";
                                                    if (reg.correccion_aceptada === 1) return "Cerrado (Aceptado)";
                                                    if (reg.correccion_aceptada === 2) return "Cerrado (No aceptado)";
                                                    return "Activo";
                                                })();

                                                const grupo = grupos.find(g => i >= g.inicio && i <= g.fin);
                                                const dibujaBarra = !!grupo;

                                                let barra = {};
                                                if (dibujaBarra) {
                                                    const esPrimero = i === grupo.inicio;
                                                    const esUltimo = i === grupo.fin;
                                                    barra = {
                                                        content: '""',
                                                        position: "absolute",
                                                        left: 0,
                                                        width: "4px",
                                                        backgroundColor: "#cc0000",
                                                        borderRadius: "2px",
                                                        top: esPrimero ? "50%" : 0,
                                                        bottom: esUltimo ? "50%" : 0
                                                    };
                                                }
                                                const fondo =
                                                    reg.esOriginalCorregido ||
                                                        reg.esCorrectorAnulado ||
                                                        reg.esAnulado 
                                                        ? "#ffe6e6"
                                                        : "white";

                                                return (
                                                    <TableRow
                                                        key={i}
                                                        sx={{
                                                            position: "relative",
                                                            backgroundColor: fondo,
                                                            height: 56,          // altura uniforme
                                                            maxHeight: 56,
                                                            minHeight: 56,
                                                            "&::before": barra
                                                        }}
                                                    >

                                                        {/* ID + botones */}
                                                        <TableCell
                                                            sx={{
                                                                minWidth: 140,
                                                                height: "52px",
                                                                display: "flex",
                                                                gap: 1,
                                                                alignItems: "center",
                                                                flexWrap: "wrap"
                                                            }}
                                                        >
                                                            {esadmin == true && (<>

                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    disabled={
                                                                        reg.esCorrector ||
                                                                        reg.esCorrectorAnulado ||
                                                                        reg.esAnulado ||
                                                                        reg.esOriginalCorregido ||
                                                                        !reg.hora_fin ||
                                                                        esCorrectorSinOriginal(reg)
                                                                    } onClick={() => { setFichajeCorregir(reg); setOpenCorregir(true); }}
                                                                >
                                                                    <AutoFixNormalIcon fontSize="small" />
                                                                </Button>

                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    disabled={reg.esAnulado || reg.esCorrectorAnulado || reg.esOriginalCorregido || !reg.hora_fin}
                                                                    onClick={() => { setFichajeAnular(reg); setOpenAnular(true); }}
                                                                >
                                                                    <TimerOffIcon fontSize="small" />
                                                                </Button>
                                                            </>)}
                                                        </TableCell>
                                                        <TableCell sx={{ minWidth: 10 }}>
                                                            <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                                                {reg.id_fichaje}

                                                            </Typography>
                                                        </TableCell>

                                                        <TableCell sx={{ minWidth: 10 }}>{formatTime(reg.total)}</TableCell>
                                                        <TableCell sx={{ minWidth: 10 }}>{Hora(reg.hora_inicio)}</TableCell>
                                                        <TableCell sx={{ minWidth: 10 }}>
                                                            {reg.hora_fin ? (
                                                                Hora(reg.hora_fin)
                                                            ) : (reg.esAnulado !== true ?
                                                                <>
                                                                    <CircleIcon color="success" sx={{ fontSize: 14, verticalAlign: "middle" }} />
                                                                    &nbsp;Activo
                                                                </> : "Anulado"
                                                            )}
                                                        </TableCell>
                                                        {/* ---- COLUMNA DE CORRECCIÓN ---- */}
                                                        <TableCell sx={{ minWidth: 200 }}>
                                                            {reg.id_fichaje_corrector !== 0 || esCorrectorSinOriginal(reg)
                                                                ? (
                                                                    <>
                                                                        <Typography variant="body2">
                                                                            <strong>Corregido por:</strong> {reg.usuario_corrector_nombre}
                                                                            <br />
                                                                            <strong>{formatearFecha(reg.fecha_corrector)}</strong>
                                                                        </Typography>

                                                                        {/* Estado de corrección */}
                                                                        {reg.correccion_aceptada === 1 && (
                                                                            <Typography variant="body2" color="green">
                                                                                <strong>Aceptado por:</strong> {reg.usuario_nombre}
                                                                                <br /> <strong>{formatearFecha(reg.fecha_correccion_respuesta)}</strong>                                                                            </Typography>
                                                                        )}

                                                                        {reg.correccion_aceptada === 2 && (
                                                                            <Typography variant="body2" color="red">
                                                                                <strong>No aceptado por:</strong> {reg.usuario_nombre}
                                                                                <br />
                                                                                <strong>{formatearFecha(reg.fecha_correccion_respuesta)}</strong>
                                                                            </Typography>
                                                                        )}

                                                                        {reg.correccion_aceptada === 0 && (
                                                                            <Typography variant="body2" color="orange">
                                                                                <strong>pendiente de aceptacion</strong>
                                                                            </Typography>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <Typography variant="body2" color="text.secondary">
                                                                        —
                                                                    </Typography>
                                                                )}
                                                        </TableCell>

                                                        {/* ---- COLUMNA DE ANULACIÓN ---- */}
                                                        {/* ---- COLUMNA DE ANULACIÓN ---- */}
                                                        <TableCell sx={{ minWidth: 200 }}>
                                                            {reg.eliminado === "1" ? (
                                                                <>
                                                                    {/* Quién anuló */}
                                                                    <Typography variant="body2" >
                                                                        <strong>Anulado por:</strong> {reg.usuario_anulador_nombre ?? "Desconocido"}<br />
                                                                        <strong>{formatearFecha(reg.fecha_anulacion)}</strong>
                                                                    </Typography>

                                                                    {/* Estado de la respuesta de anulación */}
                                                                    {reg.anulacion_respuesta === 1 && (
                                                                        <Typography variant="body2" color="green" sx={{ mt: 1 }}>
                                                                            <strong>Aceptado por:</strong> {reg.usuario_nombre}<br />
                                                                            <strong>{formatearFecha(reg.fecha_respuesta_anulacion)}</strong>
                                                                        </Typography>
                                                                    )}

                                                                    {reg.anulacion_respuesta === 2 && (
                                                                        <Typography variant="body2" color="red" sx={{ mt: 1 }}>
                                                                            <strong>No aceptado por:</strong> {reg.usuario_nombre}<br />
                                                                            <strong> {formatearFecha(reg.fecha_respuesta_anulacion)}</strong>
                                                                        </Typography>
                                                                    )}

                                                                    {/* 🔥 ESTE FALTABA — pendiente de aceptacion */}
                                                                    {(reg.anulacion_respuesta === null || reg.anulacion_respuesta === 0) && (
                                                                        <Typography variant="body2" color="orange" sx={{ mt: 1 }}>
                                                                            <strong>pendiente de aceptacion</strong>
                                                                        </Typography>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <Typography variant="body2" color="text.secondary">—</Typography>
                                                            )}
                                                        </TableCell>




                                                        <TableCell sx={{ minWidth: 120 }}>
                                                            <Typography variant="body2" noWrap>
                                                                {reg.observacion || "Sin observación"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ minWidth: 100 }}>
                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                onClick={() => handleClick(reg.latitud_inicio, reg.longitud_inicio)}
                                                            >
                                                                <PlaceIcon fontSize="small" /> Inicio
                                                            </Button>
                                                        </TableCell>

                                                        <TableCell align="center" sx={{ minWidth: 100 }}>
                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                onClick={() => handleClick(reg.latitud_fin, reg.longitud_fin)}
                                                            >
                                                                <PlaceIcon fontSize="small" /> Fin
                                                            </Button>
                                                        </TableCell>


                                                    </TableRow>

                                                );
                                            });

                                        })()}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </Grid>
                    </Collapse>
                </CardContent>
            </Card>

            {/* DIALOGOS */}
            <DialogCorregirFichaje
                open={openCorregir}
                onClose={() => setOpenCorregir(false)}
                fichaje={fichajeCorregir}
                fichajesUsuario={fichajesUsuario}
                usuarioId={usuarioId}

            />

            <DialogAnularFichaje
                open={openAnular}
                setOpen={setOpenAnular}
                fichaje={fichajeAnular}
                fichajesUsuario={fichajesUsuario}
                usuarioId={usuarioId}

            />
        </Grid>
    );
};
